import React, { useState } from 'react';
import SectionHeader from 'components_v2/common/SectionHeader';
import NewStoryCard from 'components_v2/desktop/NewStoryCard';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import makeRequest from 'utils/makeRequest';
import s from './EtimesMoreStories.scss';

const EtimesMoreStories = ({ item }) => {
  if (!(item && Array.isArray(item.items))) {
    return null;
  }

  const { items, pagination, ga4Type } = item;

  const [itemsToRender, setItemsToRender] = useState(items);
  const [nextPageUrl, setNextPageUrl] = useState(
    pagination && pagination.nextPageUrl,
  );
  //   const [loadedData, setLoadedData] = useState(item);
  const [showLoader, setLoader] = useState(false);

  const getData = dataUrl => {
    if (!dataUrl) {
      return false;
    }

    // dataUrl = dataUrl.replace(/http:/g, 'https:');

    setLoader(true);
    makeRequest
      .get(dataUrl, { isMobile: false })
      .then(data => {
        if (!(data && data.data && Array.isArray(data.data.items))) {
          setLoader(false);
          setNextPageUrl(
            data &&
              data.data &&
              data.data.pagination &&
              data.data.pagination.nextPageUrl,
          );
          return false;
        }
        setItemsToRender([...itemsToRender.concat(data.data.items)]);
        setNextPageUrl(
          data.data.pagination && data.data.pagination.nextPageUrl,
        );
        setLoader(false);
        return false;
      })
      .catch(err => {
        console.error(err);
        setLoader(false);
      });
    return false;
  };

  if (!(Array.isArray(itemsToRender) && itemsToRender.length > 0)) {
    return null;
  }

  return (
    <div
      className={
        item.classNames ? item.classNames.map(i => s[i]).join(' ') : ''
      }
    >
      <SectionHeader title={item.name} icon={item.icon} path={item.path} />

      <div className={s.content}>
        <div className={s.col_3}>
          {itemsToRender.map((value, index) => (
            <div className={s.col}>
              <NewStoryCard
                title={value.hl}
                msid={value.msid}
                syn={value.synopsis}
                isLarge={value.isLarge}
                cardType={value.cardType}
                wu={value.wu}
                index={index}
                gaIndex={value.gaIndex}
                ga4Type={ga4Type}
                ga4Label={value.ga4Label}
              />
            </div>
          ))}
        </div>
      </div>
      <div className={s.moreStoriesBtnWrap}>
        {nextPageUrl && (
          <button
            onClick={() => {
              getData(nextPageUrl);
            }}
          >
            Load More Stories
          </button>
        )}
        {showLoader && <LoaderSpinner overwriteWrapper={s.loader} />}
      </div>
    </div>
  );
};

export default EtimesMoreStories;
